import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "text-center w-100 fixed-top",
  style: {"top":"calc(50% - 10rem)"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "my-4" }, "Loading", -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "my-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("img", {
      src: _ctx.loadingGif,
      class: "img-fluid",
      style: {"width":"8rem"}
    }, null, 8, _hoisted_3),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ]))
}